import * as consts from '../common/consts';

export class Message {
  
  protected MessageType: number;

}

var userActionNumber = 1;

export class UserActionMsg extends Message {

  protected MessageNumber: number;
  protected SwitchAction: number;

  constructor() {
    super();
    this.MessageType = consts.MSG_TYPE_USER_ACTION;
    this.MessageNumber = userActionNumber++;
  }
}
